var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66665 26.0002C10.7303 26.0002 11.5926 25.1405 11.5926 24.0802C11.5926 23.0198 10.7303 22.1602 9.66665 22.1602C8.60299 22.1602 7.74072 23.0198 7.74072 24.0802C7.74072 25.1405 8.60299 26.0002 9.66665 26.0002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1851 26.0002C23.2488 26.0002 24.1111 25.1405 24.1111 24.0802C24.1111 23.0198 23.2488 22.1602 22.1851 22.1602C21.1215 22.1602 20.2592 23.0198 20.2592 24.0802C20.2592 25.1405 21.1215 26.0002 22.1851 26.0002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17314 6.79999H27L23.788 17.888C23.6734 18.2904 23.428 18.6445 23.0895 18.896C22.751 19.1475 22.3381 19.2824 21.9144 19.28H10.2588C9.83499 19.2824 9.42213 19.1475 9.08363 18.896C8.74513 18.6445 8.49972 18.2904 8.38512 17.888L3.98081 2.696C3.92261 2.4953 3.79967 2.31879 3.63062 2.1932C3.46158 2.0676 3.25563 1.99978 3.04399 2H1",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/Cart.bc5395eaba1433de423c4de2b5879eb6.svg";
export { ForwardRef as ReactComponent };